import React from "react";
import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";
import PlayCircleFilledWhiteOutlinedIcon from "@material-ui/icons/PlayCircleFilledWhiteOutlined";

export const SimpleVideoSlide = props => {
    const {background, title, textLeft, textRight, preview, callback, type_id} = props;

    return (
        <div className="simpleSlide" onClick={callback}>
            <div className="dark-overlay_simplevideo text-center">
                {type_id === 1 ? <PlayCircleFilledWhiteOutlinedIcon /> : <DescriptionOutlinedIcon />}
            </div>
            <div
                className={`${
                    preview ? "cropped-preview" : ""
                } overflow-hidden position-absolute w-100 h-100 bg_image_cover w-100`}
                style={{
                    backgroundImage: !preview ? `url(${background})` : "",
                }}
            />
            <div className="simpleSlide_content">
                <div className="mt-auto w-100">
                    <div className="overflow-hidden d-flex align-items-end h-70px">
                        <div className="simpleSlide_title font-weight-bolder elipsis_3lines">{title}</div>
                    </div>
                    <div
                        className={
                            "d-flex w-100 justify-content-between align-items-center mt-5 h-15px simple_video_footer"
                        }
                    >
                        <div className="simple_video_created_at">{textLeft}</div>
                        <div className="simple_video_duration">{textRight}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default SimpleVideoSlide;
